import { useEffect, useState } from "react";
import {
    Box,
    Drawer
} from "@mui/material";
import ButtonComponent from "../button/Button";
import { useDispatch, useSelector } from "react-redux";
import {
    setFinalTreeData,
    setSelectedTreeIds,
    setTransformedTreeData,
    setFilterApplied,
    setBottlerData,
} from "../../../redux/entitySlice";
import EntitySelector from "./EntitySelector";
import InfoPopover from "../poper/InfoPopover";
import ApiService from "../../../utils/fetch";

const BottlerSelection = () => {
    const [open, setOpen] = useState(false);

    const dispatch = useDispatch();

    const filterApplied = useSelector((state) => state.entity.filterApplied);
    const transformedTreeDataRedux = useSelector(
        (state) => state.entity.transformedTreeData
    );
    const email = useSelector((state) => state.user.email);

    // get bottler selection data
    useEffect(() => {
        if (
            transformedTreeDataRedux === null ||
            transformedTreeDataRedux.length === 0
        ) {
            const postData = async () => {
                try {
                    const payload = {
                        email: email,
                    };
                    const response = await ApiService.post(
                        "v1/bottler-selection",
                        payload
                    );
                    console.log(response.data, "raw data");

                    const bottler = response.data[0]?.bottler;
                    dispatch(setBottlerData(bottler));

                    const transformedData = transformData(response.data);

                    const allIds = getAllIds(transformedData);
                    console.log("allIds", allIds);
                    dispatch(setTransformedTreeData(transformedData));
                    dispatch(setSelectedTreeIds(allIds));
                    const filteredItems = allIds.filter((item) =>
                        item.startsWith("plant")
                    );
                    const ApplyTreeViewData = filterBottlersByPlant(
                        filteredItems,
                        transformedData
                    );

                    dispatch(setFinalTreeData(ApplyTreeViewData));

                    console.log(transformedData, "transformed setTreeData");
                } catch (error) {
                    console.error("Error posting data", error);
                }
            };
            postData();
        }
    }, [email]);

    //transform data
    const transformData = (data) => {
        return data.map((bottler, bottlerIndex) => ({
            id: `bottler${bottlerIndex + 1}`,
            label: bottler.bottler,
            children: bottler.customers.map((customer, customerIndex) => ({
                id: `customer${bottlerIndex + 1}-${customerIndex + 1}`,
                label: `${customer.customerID}`,
                customerID: customer.customerID,
                children: customer.locationIds.map((locationId, locationIndex) => ({
                    id: `plant${bottlerIndex + 1}-${customerIndex + 1}-${locationIndex + 1
                        }`,
                    label: ` ${locationId}`,
                    locationId: locationId,
                })),
            })),
        }));
    };

    // filter bottlers by plant
    const filterBottlersByPlant = (plantIds, products) => {
        return products
            .map((bottler) => {
                const filteredCustomers = bottler.children
                    .map((customer) => {
                        const matchingPlants = customer.children.filter((plant) =>
                            plantIds.includes(plant.id)
                        );
                        return matchingPlants.length > 0
                            ? {
                                customerId: customer.customerID.split("-")[0], // Extract the part before '-'
                                locationId: matchingPlants.map(
                                    (plant) => plant.locationId.split("-")[0]
                                ), // Extract the part before '-'
                            }
                            : null;
                    })
                    .filter(Boolean);

                return filteredCustomers.length > 0
                    ? { bottler: bottler.label, customerList: filteredCustomers }
                    : null;
            })
            .filter(Boolean)
            .flatMap((bottler) =>
                bottler.customerList.flatMap((customer) =>
                    customer.locationId.map((locationId) => ({
                        locationId,
                        customerId: customer.customerId,
                    }))
                )
            );
    };

    //get all Ids
    const getAllIds = (items) => {
        const ids = [];
        items.forEach((item) => {
            ids.push(item.id);
            if (item.children) {
                ids.push(...getAllIds(item.children));
            }
        });
        return ids;
    };

    // toggler handler
    const toggleDrawer = (open) => (event) => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }

        setOpen(open);
    };

    // handle call back for closing toggle box
    const handleCallback = (isOpen) => {
        setOpen(isOpen);
    }

    // on clean filer handler
    const clearFilterHandler = () => {
        dispatch(setFilterApplied(false));
        const allIds = getAllIds(transformedTreeDataRedux);
        const filteredItems = allIds.filter((item) => item.startsWith("plant"));
        const ApplyTreeViewData = filterBottlersByPlant(filteredItems, transformedTreeDataRedux);

        dispatch(setFinalTreeData(ApplyTreeViewData));
        dispatch(setSelectedTreeIds(allIds));
    };

    return (
        <div>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                {filterApplied ? (
                    <div
                        onClick={clearFilterHandler}
                        style={{
                            color: "grey",
                            cursor: "pointer",
                            textDecoration: "underline",
                            marginRight: "10px",
                        }}
                    >
                        Clear Filter
                    </div>
                ) : (
                    <div></div>
                )}
                <ButtonComponent
                    maxWidth="200px"
                    label="Select Bottler"
                    bgColor="black"
                    color="white"
                    onClick={toggleDrawer(true)}
                    height="25px"
                />
                <InfoPopover />
            </Box>

            <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
                <EntitySelector popupHandler={handleCallback} />
            </Drawer>
        </div>
    );
}
export default BottlerSelection;